import { render, staticRenderFns } from "./warnMessage.vue?vue&type=template&id=dcfcc1d6&scoped=true&"
import script from "./warnMessage.vue?vue&type=script&lang=js&"
export * from "./warnMessage.vue?vue&type=script&lang=js&"
import style0 from "./warnMessage.vue?vue&type=style&index=0&id=dcfcc1d6&prod&scoped=true&lang=css&"
import style1 from "./warnMessage.vue?vue&type=style&index=1&id=dcfcc1d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfcc1d6",
  null
  
)

export default component.exports